import { signalStore, withState } from '@ngrx/signals';
import { Direction } from '../../enum';
import { UnitOfMeasure } from '../../model';
import { UnitOfMeasureService } from '../../services';
import { initialState, withCommonMethods, withCrudMethods } from '../../state';

const initState = initialState<UnitOfMeasure>({ direction: Direction.ASC });
export const UnitOfMeasuresStore = signalStore(
  withState(initState),
  withCrudMethods(UnitOfMeasureService),
  withCommonMethods()
);
